import { reactive, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useHead } from '@unhead/vue'
import { useSearchStore } from '@/stores/searchStore'

/**
 * Manages page meta title and description based on the current route.
 * For tax transaction detail pages, it enhances the description with transaction-specific details.
 */
export function usePageMeta() {
  const route = useRoute()
  const searchStore = useSearchStore()

  const pageMeta = reactive({
    title: '',
    description: '',
  })

  useHead({
    title: () => pageMeta.title,
    titleTemplate: '%s | Extensions Admin Dashboard',
    meta: [
      {
        name: 'description',
        content: () => pageMeta.description,
      },
    ],
  })

  watch(
    [() => route.name, () => searchStore.currentTransaction],
    () => {
      pageMeta.title = route.meta.displayName as string

      if (
        route.name === 'taxTransactionDetails' &&
        searchStore.currentTransaction
      ) {
        const { Id, Merchant } = searchStore.currentTransaction
        pageMeta.description = `Transaction ID: ${Id} | Merchant: ${Merchant.Name}`
      } else {
        pageMeta.description = (route.meta.pageDescription as string) || ''
      }
    },
    { immediate: true },
  )
}
